<template>
  <div class="vacancy-page__employer-section">
    <h2 class="vacancy-page__employer-section-title">{{ $tVacancy(isRecruiterVacancy ? 'recruiter' : 'Employer') }}</h2>
    <div class="vacancy-page__element  vacancy-element" :class="{_open: isOpen(1)}">
      <VacancyCompanyLogoName
        v-if="vacancy.employer"
        :vacancy="vacancy"
        :show-employer-company-type-alert="isRecruiterVacancy"
        isEmployer
        class="d-sm-none vacancy-element__item"
      />
      <div v-if="windowSizeMixin.width <= WINDOW_SIZE_SM || vacancy[3].work_place_procedures"
           class="vacancy-element__head" @click="onToggle(1)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-passport-card"
                   width="3.2rem"
                   height="3.2rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">{{ $tVacancy('Registration procedure') }}</h4>
        <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>
      <div v-if="windowSizeMixin.width <= WINDOW_SIZE_SM || vacancy[3].work_place_procedures"
           class="vacancy-element__toggle">
        <VacancyCompanyLogoName :vacancy="vacancy"
                                v-if="vacancy.employer"
                                :show-employer-company-type-alert="isRecruiterVacancy"
                                isEmployer
                                class="d-none d-sm-block vacancy-element__item"/>

        <div v-html="vacancy[3].work_place_procedures"
             class="vacancy-element__text  text"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import VacancyCompanyLogoName from '@/components/vacancy/VacancyCompanyLogoName'
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'

  export default {
    name: 'VacancyEmployerSection',
    mixins: [windowSizeMixin],
    components: {VacancyCompanyLogoName},
    props: ['vacancy'],
    data() {
      return {
        WINDOW_SIZE_SM,
        toggleSections: []
      }
    },
    computed: {
      isRecruiterVacancy() {
        return this.vacancy.employer_information?.company_type === 1;
      },
    },
    methods: {
      isOpen(id) {
        return this.toggleSections.some(item => item === id)
      },
      onToggle(id) {
        if (window.innerWidth > WINDOW_SIZE_SM) return
        if (this.isOpen(id)) {
          this.toggleSections = this.toggleSections.filter(item => item !== id)
        } else {
          this.toggleSections.push(id)
        }
      }
    },
  }
</script>

<style>

</style>
